<template>
  <div class="shipping-timeline">
    <div v-for="step in steps" :key="step.num" class="timeline-step">
      <div class="timeline-num">{{ step.num }}</div>
      <div class="timeline-label">{{ step.label }}</div>
      <div class="timeline-title">{{ step.title }}</div>
      <div class="timeline-desc">{{ step.desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShippingTimeline",
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
};
</script>
